module.exports = __webpack_public_path__ + "img/enquiry.a4d57a9d.svg";